import _useTasks_tasks from "./__generated__/useTasks_tasks.graphql";
import { getEdgeNodes, graphql, useFragment } from "@workflows/runtime-web";
import { FilterInputType } from "@workflows/ui";
import { DashboardBodyQuery$data } from "../../dashboard/__generated__/DashboardBodyQuery.graphql";
import { useTasks_tasks$key } from "./__generated__/useTasks_tasks.graphql";
import { useViewer } from "../../core/hooks/useViewer";
import { SortInputValue } from "../../core/sort";
interface UseTasksProps {
  numberOfTasks?: number;
  taskSort?: SortInputValue[];
  filter?: FilterInputType | null;
  page?: number;
}
export const useTasks = ({
  numberOfTasks = 10,
  taskSort,
  filter,
  page
}: UseTasksProps) => {
  const viewer = useViewer({
    numberOfTasks,
    taskSort,
    filter,
    page,
    limit: numberOfTasks
  });
  const data = useFragment<useTasks_tasks$key>(Fragment, viewer);
  return {
    tasks: getEdgeNodes(data?.tasks || null),
    hasNextPage: data?.tasks?.pageInfo.hasNextPage,
    total: data?.tasks?.total || 0,
    countGroupedByStatus: data?.tasks?.countGroupedByStatus
  };
};
export const useTasksFragment = (queryRef: DashboardBodyQuery$data) => {
  const data = useFragment<useTasks_tasks$key>(Fragment, queryRef?._viewer);
  return {
    tasks: getEdgeNodes(data?.tasks || null),
    hasNextPage: data?.tasks?.pageInfo.hasNextPage,
    total: data?.tasks?.total || 0,
    countGroupedByStatus: data?.tasks?.countGroupedByStatus
  };
};
const Fragment = (_useTasks_tasks.hash && _useTasks_tasks.hash !== "c2a77e6c09b890dd030686de7eed033d" && console.error("The definition of 'useTasks_tasks' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useTasks_tasks);